import { Component, OnInit } from '@angular/core';
import { Item } from '@app/core/components/listbox/listbox.component';
import { SrCrewResourceViewGet, SrCrewService } from '@app/services/sr-crew.service';

@Component({
    selector: 'tt-sr-crew-resource-view',
    templateUrl: './sr-crew-resource-view.component.html',
    styleUrls: ['./sr-crew-resource-view.component.css'],
    standalone: false,
})
export class SrCrewResourceViewComponent implements OnInit {
    public page?: SrCrewResourceViewGet;
    public mainResources: Item[] = [];
    public subResources: Item[] = [];
    public resourceViews: Item[] = [];
    private mainVersion = 0;
    private subVersion = 0;

    constructor(private readonly crew: SrCrewService) {}

    public async ngOnInit(): Promise<void> {
        const [page, mainResources] = await Promise.all([this.crew.getResourceView(), this.crew.getMainResources()]);
        this.page = page;
        this.mainResources = mainResources;
        await Promise.all([this.loadSubResources(), this.loadResourceViews()]);
    }

    public async onMainResourceChanged(value: string): Promise<void> {
        if (!this.page || this.page.main_resource_id === value) return;
        this.page.main_resource_id = value;
        await this.loadSubResources();
    }

    public async onSubResourceChanged(value: string): Promise<void> {
        if (!this.page || this.page.sub_resource_id === value) return;
        this.page.sub_resource_id = value;
        await this.loadResourceViews();
    }

    private async loadSubResources(): Promise<void> {
        const version = ++this.mainVersion;
        const id = this.page?.main_resource_id;
        if (!id?.trim()) return;
        this.subResources = [];
        const resources = await this.crew.getSubResources({ main_resource_id: id });
        if (version === this.mainVersion) this.subResources = resources;
    }

    private async loadResourceViews(): Promise<void> {
        const version = ++this.subVersion;
        const id = this.page?.sub_resource_id;
        if (!id?.trim()) return;
        this.resourceViews = [];
        const resources = await this.crew.getResourceViews({ sub_resource_id: id });
        if (version === this.subVersion) this.resourceViews = resources;
    }
}
